module.exports = __webpack_public_path__ + "static/media/srm1.4990e724.png";